import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import moment from "moment/moment";
import {InputNumber} from "primereact/inputnumber";
import {InputMask} from "primereact/inputmask";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";

const RetentionListComponent = (props) => {

  const {t, fulfillmentStatus, fulfillmentId, fulfillmentCurrency} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  // const isParentClosed = fulfillmentStatus?.toUpperCase() === 'CLOSED' || fulfillmentStatus?.toUpperCase() === 'DELETED';
  const [retentions, setRetentions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);

  const [releaseDateFrom, setreleaseDateFrom] = useState('');
  const [releaseDateTo, setreleaseDateTo] = useState('');
  const [dsStatus, setDsStatus] = useState(null);
  const [amountMin, setAmountMin] = useState(null);
  const [amountMax, setAmountMax] = useState(null);

  const [statusDialogVisible, setStatusDialogVisible] = useState(false);
  const [selectedRetention, setSelectedRetention] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const [statusNote, setStatusNote] = useState('');
  const [statusLoading, setStatusLoading] = useState(false);
  

  const [dateInvalid, setDateInvalid] = useState({
    releaseDateFrom: false,
    releaseDateTo: false,
  });
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const [statuses, setStatuses] = useState([]);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);
      if (fulfillmentId) {
        query += `${query.includes('?') ? '&' : '?'}search[fulfillment][operator]=%3D&search[fulfillment][value]=${fulfillmentId}`;
      }
      const aMin = amountMin !== null ? amountMin * 100 : null;
      const aMax = amountMax !== null ? amountMax * 100 : null;

      let amtQuery = '';
      if (aMin !== null && aMax !== null) {
        amtQuery = `search[amount][operator]=between&search[amount][value]=${aMin},${aMax}`;
      } else if (aMin !== null) {
        amtQuery = `search[amount][operator]=>=&search[amount][value]=${aMin}`;
      } else if (aMax !== null) {
        amtQuery = `search[amount][operator]=<=&search[amount][value]=${aMax}`;
      }
      if (amtQuery) query += `${query.includes('?') ? '&' : '?'}${amtQuery}`;


      let dateQuery = '';
      const fromValid = releaseDateFrom && isValidDateString(releaseDateFrom);
      const toValid = releaseDateTo && isValidDateString(releaseDateTo);

      if (fromValid && toValid) {
        dateQuery = `search[release_date][operator]=between&search[release_date][value]=${releaseDateFrom},${releaseDateTo}`;
      } else if (fromValid) {
        dateQuery = `search[release_date][operator]=>=&search[release_date][value]=${releaseDateFrom}`;
      } else if (toValid) {
        dateQuery = `search[release_date][operator]=<=&search[release_date][value]=${releaseDateTo}`;
      }
      if (dateQuery) query += `${query.includes('?') ? '&' : '?'}${dateQuery}`;

      if (dsStatus) {
        query += `${query.includes('?') ? '&' : '?'}search[payment_status][operator]=%3D&search[payment_status][value]=${dsStatus}`;
      }
      apiCall('get', '/api/v2/retention' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setRetentions(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
      setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const saveStatusChange = () => {
    if (!newStatus) return;
    setStatusLoading(true);
    const payload = {
      payment_status: newStatus,
      note: statusNote
    };
    if (selectedRetention?.retention_category?.rate_percent === false) {
      payload.amount = selectedRetention.amount;
    } else {
      payload.percentage = selectedRetention.percentage;
    }
    apiCall('patch', `/api/v2/retention/${selectedRetention.id}`, payload)
    .then((response) => {
      window.App.toastShow('success', t('success'), 'Státusz sikeresen módosítva');
      setStatusDialogVisible(false);
      loadLazyData();
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString());
    })
    .finally(() => setStatusLoading(false));
  };

  const formatRetentionAmount = (currency, amount) => {
    const n = Number(amount);
    if (!Number.isFinite(n)) {
      return '';
    }
    const hasDecimal = !Number.isInteger(n);
    if (!hasDecimal) {
      return window.App.currencyFormatter(currency || 'HUF', n);
    }
    const locale = (localStorage.getItem('user.locale') || localStorage.getItem('userLocale') || 'hu').toString().toLowerCase();
    const ccy = (currency || 'HUF').toString().toUpperCase();
    const symbolMap = { HUF: 'Ft', EUR: '€', USD: '$', GBP: '£' };
    const symbol = symbolMap[ccy] || ccy;
    const formatted = new Intl.NumberFormat(
      locale.startsWith('en') ? 'en-US' : 'hu-HU',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    ).format(n);
    return (
      <>
        {formatted}&nbsp;{symbol}
      </>
    );
  };

  const isRetentionDateOnlyEditable = (rowData) => {
    const parentStatus = rowData?.fulfillment?.status?.toUpperCase?.() || fulfillmentStatus?.toUpperCase?.() || '';
    const isClosed = parentStatus === 'CLOSED' || parentStatus === 'DELETED';
    const hasReleaseOnDate = !!rowData?.retention_category?.release_on_date;
    const isPaid = String(rowData?.payment_status || '').toUpperCase() === 'PAID';
    return isClosed && hasReleaseOnDate && !isPaid;
  };

  const canEditRetention = (rowData) => {
    const parentStatus = rowData?.fulfillment?.status?.toUpperCase?.() || fulfillmentStatus?.toUpperCase?.() || '';
    const isClosed = parentStatus === 'CLOSED' || parentStatus === 'DELETED';
    if (!isClosed) {
      return true;
    }
    return isRetentionDateOnlyEditable(rowData);
  };

  const isValidDateString = (value) => {
    if (!value || value.includes('_')) {
      return false;
    }
    return moment(value, 'YYYY-MM-DD', true).isValid();
  };

  const handleMaskedDateChange = (value, setter, key) => {
    setter(value);
    if (!value || value.replace(/_/g, '').trim() === '') {
      setDateInvalid(prev => ({...prev, [key]: false}));
      return;
    }
    setDateInvalid(prev => ({
      ...prev,
      [key]: !isValidDateString(value),
    }));
  };

  const amountFilterTemplate = () => (
    <div className="p-grid p-ai-center p-m-0 p-fluid" style={{ minWidth: '15rem' }}>
      <div className="p-col p-p-0">
        <InputNumber value={amountMin} onValueChange={(e) => setAmountMin(e.value)} placeholder={t('minPlaceholder')} inputClassName="p-inputtext-sm" useGrouping={false} />
      </div>
      <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
        <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
      </div>
      <div className="p-col p-p-0">
        <InputNumber value={amountMax} onValueChange={(e) => setAmountMax(e.value)} placeholder={t('maxPlaceholder')} inputClassName="p-inputtext-sm" useGrouping={false} />
      </div>
    </div>
  );

  const releaseDateFilterTemplate = () => (
    <div className="p-grid p-ai-center p-m-0 p-fluid" style={{ minWidth: '16rem' }}>
      <div className="p-col p-p-0">
        <InputMask value={releaseDateFrom} mask="9999-99-99" placeholder={t('datePlaceholder')}className="p-inputtext-sm" onChange={(e) => handleMaskedDateChange(e.value, setreleaseDateFrom, 'releaseDateFrom')} />
      </div>
      <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
        <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
      </div>
      <div className="p-col p-p-0">
        <InputMask value={releaseDateTo} mask="9999-99-99" placeholder={t('datePlaceholder')}className="p-inputtext-sm" onChange={(e) => handleMaskedDateChange(e.value, setreleaseDateTo, 'releaseDateTo')} />
      </div>
    </div>
  );

  const statusFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value || null}
        options={statuses}
        optionLabel="value"
        optionValue="key"
        placeholder={t('all')}appendTo={document.body}
        onChange={(e) => options.filterApplyCallback(e.value)}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {rowData.compensation_invoice === null &&
          <Button icon="pi pi-file" className="p-button-secondary p-mr-2"
                  disabled
                  tooltip="Komenzációs számla kiállítása" tooltipOptions={{position: 'left'}}
                  onClick={() => {

                  }}/>
        }
        {entity === 'retention' && (
          <Button 
            icon="pi pi-refresh" 
            className="p-button-info p-mr-2"
            tooltip={t('statusUpdate')} 
            tooltipOptions={{position: 'left'}}
                onClick={() => {
                    setSelectedRetention(rowData);
                    setNewStatus(rowData.payment_status);
                    setStatusNote('');
                    setStatusDialogVisible(true);
                }}
            />
          )}

        {localStorage.getItem('roles').toString().includes('role_retention_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  disabled={!canEditRetention(rowData)}
                  onClick={() => {
                    if(entity === 'retention') {
                      history.push('/finance/retention/update/' + rowData.id)
                    }
                    if(entity === 'project') {
                      history.push('/project/project/' + action +"/" + id + "?update=retention&retentionId=" + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_retention_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/retention/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderRetentionList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
    apiCall('get', '/api/v2/dictionary/payment-status')
      .then(response => {
        setStatuses(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [lazyParams, window.App.state.rerenderRetentionList])

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, amountMin, amountMax, releaseDateFrom, releaseDateTo, window.App.state.rerenderRetentionList]);

  return (
    <>
      <Dialog 
        header={t('statusUpdate')} 
        visible={statusDialogVisible} 
        style={{ width: '400px' }} 
        modal 
        onHide={() => setStatusDialogVisible(false)}
        footer={
            <div>
                <Button label="Mégse" icon="pi pi-times" onClick={() => setStatusDialogVisible(false)} className="p-button-text" />
                <Button label="Mentés" icon="pi pi-check" onClick={saveStatusChange} loading={statusLoading} autoFocus />
            </div>
        }
    >
        <div className="p-fluid">
            <div className="p-field p-mb-3">
                <label htmlFor="status-select" className="p-d-block p-mb-2">{t('fieldNewStatus')}</label>
                <Dropdown 
                    id="status-select"
                    value={newStatus} 
                    options={statuses} 
                    optionLabel="value" 
                    optionValue="key" 
                    placeholder={t('selectStatusPlaceholder')}onChange={(e) => setNewStatus(e.value)} 
                />
            </div>
            <div className="p-field">
                <label htmlFor="note" className="p-d-block p-mb-2">{t('fieldNote')}</label>
                <InputTextarea 
                    id="note"
                    value={statusNote} 
                    onChange={(e) => setStatusNote(e.target.value)} 
                    rows={3} 
                    autoResize 
                    placeholder={t('comment') + '...'}
                />
            </div>
        </div>
    </Dialog>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={retentions} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column style={{position: 'relative', width: '10px', maxWidth: '10px'}}
                body={(rowData) => {
                  if (rowData && rowData.color) {
                    return (
                      <span style={{
                        position: 'absolute',
                        left: '0',
                        top: '0',
                        height: '100%',
                        borderLeft: '10px solid ' + rowData.color,
                      }}></span>
                    )
                  }
                }}/>
        <Column field="retention_category.name" header={t('columnName')} bodyClassName="col-body-font-bold" filter filterField='retention_category_name' sortable></Column>
        <Column field="fulfillment.partner.name" header={t('columnCustomer')} bodyClassName="col-body-font-bold" sortable filter filterField='partner_name'></Column>
        <Column field="fulfillment.project.name" header={t('columnProject')} bodyClassName="col-body-font-bold" sortable filter filterField="project_name"></Column>
        <Column field="amount" header={t('columnRetainedAmount')} sortable filter filterField='amount' filterMatchMode='between' filterElement={amountFilterTemplate}
         style={{ minWidth: '18rem' }}
         body={(rowData) => {
             const formatted = window.App.currencyFormatter(props.fulfillmentCurrency || rowData?.currency || 'HUF', rowData.amount);
            return (
              <>
                {formatted} {rowData?.percentage ? ` (${rowData.percentage}%)` : ''}
              </>
            );
          }}
        ></Column>
        <Column field="release_date" header={t('columnRetentionExpiryDate')} sortable filter filterMatchMode='between' filterElement={releaseDateFilterTemplate}
         style={{ minWidth: '20rem' }} body={(rowData) => {
          if (!rowData?.release_date) {
            return <span style={{opacity: 0.6}}>Nincsen határidő</span>;
          }
          return window.App.formatDateValue(rowData.release_date);
        }}></Column>
        <Column field="note" header={t('columnComment')} sortable filter></Column>
        <Column field="payment_status" header={t('columnStatus2')} sortable filter filterMatchMode='equals' filterElement={statusFilterTemplate} body={(rowData) => {
          let status = statuses.find(status => status.key === rowData.payment_status)
          return(
            <>
            {status?.value || ''}
            </>
          )
        }}></Column>
        {/* <Column field="fulfillment.name" header={t('columnFulfillment')} sortable></Column>
        <Column field="percentage" header={t('columnPercentage')} sortable></Column>
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column> */}
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(RetentionListComponent);
